import {
  Component,
  AfterViewInit,
  ViewChild,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { ReservationService } from "../services/reservation-service/reservation.service";
import swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from '@angular/common';

@Component({
  selector: "app-json-editor-modal",
  templateUrl: "./json-editor-modal.component.html",
  styleUrls: ["./json-editor-modal.component.css"],
})
export class JsonEditorModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild("editorContainer") editorContainer!: ElementRef;

  editor: any;
  options = {
    mode: "tree",
    modes: ["code", "form", "text", "tree", "view"],
    onError: (err: any) => {
      alert(err.toString());
    },
  };

  json: any;
  log_id: number;

  constructor(
    private _router: Router,
    private _activtedRoute: ActivatedRoute,
    private _location: Location,
    private _reservationServices: ReservationService,
    private _errorHandlerService: ErrorHandlerService
  ) {
    this.json = JSON.parse(localStorage.getItem("json"));
    _activtedRoute.params.subscribe((params) => {
      this.log_id = params["id"];
    });
  }

  ngAfterViewInit(): void {
    this.initializeEditor();
  }

  ngOnDestroy(): void {
    this.destroyEditor();
  }

  private initializeEditor(): void {
    if (!this.editorContainer) {
      swal("Oops... \n JSONEditor container is not initialized!", "", "error");
      return;
    }

    try {
      this.editor = new JSONEditor(
        this.editorContainer.nativeElement,
        this.options
      );
      this.editor.set(this.json);
    } catch (err) {
      swal(`Failed to initialize JSONEditor \n ${err}`, "", "error");
    }
  }

  private destroyEditor(): void {
    if (this.editor) {
      try {
        this.editor.destroy();
      } catch (err) {
        swal(`Failed to destroy JSONEditor \n ${err}`, "", "error");
      }
    }
    localStorage.removeItem("json");
  }

  submit(): void {
    if (!this.editor) {
      swal("Oops... \n JSONEditor is not initialized!", "", "error");
      return;
    }

    const updatedJson = this.editor.get();
    const payload = {
      data: updatedJson,
    };
    this._reservationServices.editJsonObject(this.log_id, payload).subscribe(
      (res: any) => {
        swal(`Success! \n ${res.data}`, "", "success")
          .then(() => {
            this._location.back();
          })
      },
      (err) => {
        this._errorHandlerService.handleErorr(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/json-editor-modal/json-editor-modal.component.ts